import { useNavigation } from '@/contexts/NavigationContext';

export const useFavorites = () => {
  const { favorites, toggleFavorite, isFavorite } = useNavigation();

  return {
    favorites,
    toggleFavorite,
    isFavorite,
    favoritesCount: favorites.length,
  };
};

